import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';
import checkbox from 'four-nets/icons/svg/icon_checkbox.svg';
import checkboxActive from 'four-nets/icons/svg/icon_checkbox_active.svg';
import defaultStyles from './checkbox-input-view.scss';

@Styled(defaultStyles)
@observer
class CheckboxInputView extends React.Component {
    @observable checked = false;

    onChange = event => {
        this.checked = !this.checked;
        this.props.onChange(event);
    };

    render() {
        const { id, value, styles } = this.props;

        return (
            <span className={styles.checkboxInput}>
                <input id={id} onChange={this.onChange} value={value} type='checkbox' className={styles.input} />
                <SVGIcon style={{ image: styles.icon }} src={this.checked ? checkboxActive : checkbox} />
            </span>
        );
    }
}

export default CheckboxInputView;
